import { DraftLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { getProduct } from '#/products/domain';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';

const options = ['BUY', 'SELL'];

export function actionView(
  action: DraftLeg['action'],
  productCode: string,
  isHedge: boolean,
) {
  const { venue } = getProduct(productCode);
  const isDisabled = !isHedge && !venueSupportsCustomStrategy(venue);
  return { options, selectedOption: action, isDisabled };
}
